module.exports = __webpack_public_path__ + "static/media/druid.c0322035.png";